import { render, staticRenderFns } from "./BlogArticles.vue?vue&type=template&id=63dfd0e9&scoped=true&"
import script from "./BlogArticles.vue?vue&type=script&lang=ts&"
export * from "./BlogArticles.vue?vue&type=script&lang=ts&"
import style0 from "./BlogArticles.vue?vue&type=style&index=0&id=63dfd0e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dfd0e9",
  null
  
)

export default component.exports